import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.formTemplate.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.formTemplate.fields.name'),
  },
  {
    name: 'category',
    label: i18n('entities.formTemplate.fields.category'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'description',
    label: i18n('entities.formTemplate.fields.description'),
  },
  {
    name: 'version',
    label: i18n('entities.formTemplate.fields.version'),
  },
  {
    name: 'previewImage',
    label: i18n(
      'entities.formTemplate.fields.previewImage',
    ),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'validatorsRequired',
    label: i18n(
      'entities.formTemplate.fields.validatorsRequired',
    ),
    render: exporterRenders.boolean(),
  },
  {
    name: 'validators',
    label: i18n('entities.formTemplate.fields.validators'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'actionPlansRequired',
    label: i18n(
      'entities.formTemplate.fields.actionPlansRequired',
    ),
    render: exporterRenders.boolean(),
  },
  {
    name: 'actionPlans',
    label: i18n('entities.formTemplate.fields.actionPlans'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'adminsRequired',
    label: i18n(
      'entities.formTemplate.fields.adminsRequired',
    ),
    render: exporterRenders.boolean(),
  },
  {
    name: 'administrators',
    label: i18n(
      'entities.formTemplate.fields.administrators',
    ),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'priority',
    label: i18n('entities.formTemplate.fields.priority'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.formTemplate.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.formTemplate.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
